"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _utils = require("../../utils");

var _CheckboxSvg = _interopRequireDefault(require("./CheckboxSvg"));

var _Tick = _interopRequireDefault(require("./Tick"));

var _helperComponents = require("./helperComponents");

var _interfaces = require("./interfaces");

var _propTypes = require("./propTypes");

var _core = require("@emotion/core");

var _excluded = ["colorScheme", "disabled", "error", "indeterminate"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Checkbox = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, externalRef) {
  var _ref$colorScheme = _ref.colorScheme,
      colorScheme = _ref$colorScheme === void 0 ? _interfaces.CheckboxColorScheme.Default : _ref$colorScheme,
      disabled = _ref.disabled,
      error = _ref.error,
      indeterminate = _ref.indeterminate,
      props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var inputDataTestProps = (0, _utils.buildDataTestProps)({
    // TODO: remove in 4.x to use `Stencil${displayName}` dataTestComponent
    dataTestComponent: 'StencilReactCheckboxInput'
  });
  var checkboxRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var checkbox = checkboxRef.current;

    if (!checkbox) {
      return;
    }

    checkbox.indeterminate = !!indeterminate;
  }, [indeterminate]);
  return (0, _core.jsx)(_helperComponents.CheckOuter, (0, _utils.pickDataTestProps)(props), (0, _core.jsx)(_helperComponents.CheckHidden, (0, _extends2.default)({}, inputDataTestProps, (0, _utils.omitDataTestProps)(props), {
    className: "stencilCheckboxHidden",
    disabled: disabled,
    ref: (0, _utils.mergeRefs)(checkboxRef, externalRef),
    type: "checkbox"
  })), (0, _core.jsx)(_Tick.default, {
    colorScheme: colorScheme,
    disabled: disabled,
    error: error
  }, (0, _core.jsx)(_CheckboxSvg.default, null), (0, _core.jsx)(_helperComponents.IndeterminateBar, {
    className: "stencilIndeterminateBar"
  })));
});

var _default = (0, _utils.composeStencilComponent)({
  baseComponent: Checkbox,
  // TODO: remove in 4.x to use `Stencil${displayName}` dataTestComponent
  dataTestComponent: 'StencilReactCheckbox',
  description: 'Basic form element for selecting an option that is either on or off.',
  displayName: 'Checkbox',
  propTypes: _propTypes.checkboxPropTypes
});

exports.default = _default;